export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-modal/index.js